import { getApiToken } from './authConfig';

const API_BASE = process.env.REACT_APP_API_URL || '';

/**
 * Authenticated fetch wrapper
 */
async function apiFetch(endpoint, options = {}) {
  const token = await getApiToken();

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || error.message || `HTTP ${response.status}`);
  }

  return response.json();
}

// ===== TENDER API =====

export async function fetchTenders(category = 'all') {
  const params = category !== 'all' ? `?category=${category}` : '';
  const data = await apiFetch(`/tenders${params}`);
  return data.tenders || [];
}

export async function fetchTender(rowKey) {
  return apiFetch(`/tenders/${rowKey}`);
}

export async function createTender(tender) {
  return apiFetch('/tenders', {
    method: 'POST',
    body: JSON.stringify(tender),
  });
}

export async function updateTender(rowKey, updates) {
  return apiFetch(`/tenders/${rowKey}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
}

export async function deleteTender(rowKey) {
  return apiFetch(`/tenders/${rowKey}`, { method: 'DELETE' });
}

export async function moveTender(rowKey, category) {
  return apiFetch(`/tenders/${rowKey}/move`, {
    method: 'POST',
    body: JSON.stringify({ category }),
  });
}

export async function copyTender(rowKey, category) {
  return apiFetch(`/tenders/${rowKey}/copy`, {
    method: 'POST',
    body: JSON.stringify({ category }),
  });
}

export async function updateTenderColor(rowKey, color) {
  return apiFetch(`/tenders/${rowKey}/color`, {
    method: 'PUT',
    body: JSON.stringify({ color }),
  });
}

// ===== USER API =====

export async function fetchCurrentUser() {
  return apiFetch('/users/me');
}

export async function fetchUsers() {
  const data = await apiFetch('/users');
  return data.users || [];
}

export async function fetchAdUsers() {
  const data = await apiFetch('/users/ad');
  return data.users || [];
}

export async function upsertUser(email, displayName, role) {
  return apiFetch('/users', {
    method: 'POST',
    body: JSON.stringify({ email, displayName, role }),
  });
}

export async function deleteUser(email) {
  return apiFetch(`/users/${encodeURIComponent(email)}`, { method: 'DELETE' });
}

export async function updateUserNotifications(email, receiveNotifications) {
  return apiFetch(`/users/${encodeURIComponent(email)}/notifications`, {
    method: 'PATCH',
    body: JSON.stringify({ receiveNotifications }),
  });
}
